import { Column, Entity, ManyToOne, PrimaryColumn } from 'typeorm';

import { SubjectModelSchema } from './subjectModel.schema';

/**
 * SubjectModelLocationsSchema インターフェイス。
 */
export interface ISubjectModelLocationsSchema {
  id: string;
  subjectModelId: string;
  version: number;
  locations: string;
  isNewestVersion: boolean;
  subjectModel: SubjectModelSchema;
}

export interface LeafLocation{
  name:string;
  identifier:string;
}

@Entity()
export class SubjectModelLocationsSchema implements ISubjectModelLocationsSchema {
  @PrimaryColumn()
    id: string;

  @Column({ nullable: true })
    subjectModelId: string | null;

  @Column({ nullable: true })
    version: number | null;

  @Column({ nullable: true })
    locations: string | null;

  @Column({ nullable: true })
    isNewestVersion: boolean | null;

  // relations

  @ManyToOne('SubjectModelSchema', 'locations')
    subjectModel: SubjectModelSchema;

  constructor(subjectModelId: string, version: number, locations: any, isNewestVersion: boolean) {
    this.id = `${subjectModelId}_${version}`;
    this.subjectModelId = subjectModelId;
    this.version = version;
    this.locations = JSON.stringify(locations);
    this.isNewestVersion = isNewestVersion;
  }
}
